import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta';

import Element from 'element-ui'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'

library.add(faUserSecret)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// import './styles/element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/index.scss'

import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/style.css'

import wow from 'wowjs'
Vue.prototype.$wow = wow
import 'wowjs/css/libs/animate.css'

Vue.use(VXETable)

Vue.config.productionTip = false
Vue.use(Element)

Vue.use(VueMeta);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
